export default __webpack_public_path__ + "static/media/slide14.713e8834.webp";